module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_copy_secondary-14343397cc68c24e152e4da61a85861b.svg";